import { trackAnalyticsEvent } from '../track'

interface TrackVaultV2TimelocksToggledParams {
  vaultAddress: string
  chainId: number
  isExpanded: boolean
  otherTimelockCount: number
}

export function trackVaultV2TimelocksToggled({
  vaultAddress,
  chainId,
  isExpanded,
  otherTimelockCount
}: TrackVaultV2TimelocksToggledParams) {
  trackAnalyticsEvent('vault_v2_timelocks_toggled', {
    vault_address: vaultAddress,
    chain_id: chainId,
    is_expanded: isExpanded,
    other_timelock_count: otherTimelockCount
  })
}
